import React, { useEffect, useState } from "react";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import Alert from "react-bootstrap/Alert";

import "./MainPage.css";
import config from "../config.json";

import CategoryCard from "../components/Cards/CategoryCard";
import ChartCard from "../components/Cards/ChartCard";
import HeaderCard from "../components/Cards/HeaderCard";
import MainInfoCard from "../components/Cards/MainInfoCard";
import ListSearchEntity from "../components/Cards/ListSearchEntity";

function ExecutiveDetails({ setSidebarDiv, sidebarDiv }) {
  const [entityData, setEntityData] = useState("");
  const [entityCategories, setEntityCategories] = useState("");
  const [entityTraining, setEntityTraining] = useState("");
  const [entityList, setEntityList] = useState("");
  const [overallScore, setOverallScore] = useState("");
  const [overallCategories, setOverallCategories] = useState("");
  const [trainingChartData, setTrainingChartData] = useState("");
  const [entityQuery, setEntityQuery] = useState("");
  const [invalidInputAlert, setInvalidInputAlert] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await fetch(
        config.domainName + ":" + config.port + "/api/entityquery",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            function: "AllEntities",
          }),
        }
      );

      const response2 = await fetch(
        config.domainName + ":" + config.port + "/api/entityquery",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            function: "AllEntityCompentancies",
          }),
        }
      );

      const response3 = await fetch(
        config.domainName + ":" + config.port + "/api/entityquery",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            function: "AllFunctionCategory",
          }),
        }
      );

      const response4 = await fetch(
        config.domainName + ":" + config.port + "/api/entityquery",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            function: "AllEntityTrainingNeeds",
          }),
        }
      );

      const content = await response.json();
      const content2 = await response2.json();
      const content3 = await response3.json();
      const content4 = await response4.json();

      setOverallScore(content2);
      setOverallCategories(content3["function categories"]);
      setEntityList(content.entities);

      setTrainingChartData(content4["Unique Training Courses"]);
    })();
  }, []);

  const selectEntity = async (e) => {
    e.preventDefault();

    const entity = entityList.find((item) => item["entity id"] === entityQuery);
    if (!entity) {
      // employeeQuery is not found within employeeData
      setInvalidInputAlert(true);
      setSidebarDiv(false);

      return;
    }
    setInvalidInputAlert(false);
    const response = await fetch(
      config.domainName + ":" + config.port + "/api/entityquery",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          function: "AllEntityData",
          entity_id: entityQuery,
        }),
      }
    );

    const response2 = await fetch(
      config.domainName + ":" + config.port + "/api/entityquery",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          function: "FunctionCategory",
          entity_id: entityQuery,
        }),
      }
    );

    const response3 = await fetch(
      config.domainName + ":" + config.port + "/api/entityquery",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          function: "EntityTrainingNeeds",
          entity_id: entityQuery,
        }),
      }
    );

    const content = await response.json();
    const content2 = await response2.json();
    const content3 = await response3.json();

    setEntityData(content);
    setEntityCategories(content2["function categories"]);
    setEntityTraining(content3["Unique Training Courses"]);
    setSidebarDiv(true);
  };

  const suggestionToQuery = (newQueryname, newQueryID) => {
    document.getElementById("entName").value = newQueryID;
    setEntityQuery(newQueryname);
  };

  const clearEntityQuery = (clearing) => {
    if (clearing) {
      document.getElementById("entName").value = "";
      setInvalidInputAlert(false);
      setSidebarDiv(false);
    }
    setEntityQuery("");
    setEntityData("");

    document.getElementById("entName").disabled = false;
  };

  return (
    <div id="home" className="bg-image">
      <div>
        <HeaderCard
          isEntity={false}
          paragraph={
            "The aim for the assessment is to enhance cyber security capabilities, knowledge, and skills to achieve and contribute to building a robust cyber security professionalism and promote security maturity across ADGEs."
          }
        />
        <div className="mainPageDiv">
          <MDBRow className="row-cols-1 row-col-md-12 g-4 d-flex justify-content-center">
            <MDBCol>
              <MainInfoCard
                isHeader={true}
                isEntity={false}
                logoImg={"/mainLogos/adda-logo.png"}
                col1Num={entityList.length}
                overallGrade={String(overallScore.grade)}
                overallGradeImg={`/grades/grade-${overallScore.grade}-hollow.png`}
                overallScore={String(overallScore["all entities grade"])}
                overallScoreColor={overallScore["color"]}
              />
            </MDBCol>

            <MDBCol id="overallTable">
              <CategoryCard
                tableCategories={overallCategories}
                heading={"Category Evaluation"}
              />
            </MDBCol>

            <MDBCol id="execRecommend">
              <ChartCard
                title={"Recommended Training"}
                errorMessage={
                  "Recommended training chart data could not be found"
                }
                chartInputData={trainingChartData}
              />
            </MDBCol>

            <MDBCol id="entitySearch">
              {entityList !== "" && (
                <>
                  <ListSearchEntity
                    title={"Entity Selection"}
                    setEntityQuery={setEntityQuery}
                    entityQuery={entityQuery}
                    selectEntity={selectEntity}
                    suggestionToQuery={suggestionToQuery}
                    entityList={entityList}
                    clearEntityQuery={clearEntityQuery}
                  />
                </>
              )}
            </MDBCol>
            {invalidInputAlert && (
              <Alert variant="danger">
                Invalid Input - This is not a valid input for an Entity Name.
                Please try again
              </Alert>
            )}
            {entityData !== "" && (
              <>
                <MDBCol id="entityTitle">
                  <MainInfoCard
                    isHeader={false}
                    isEntity={true}
                    logoImg={`/entity logos/logo-${entityData["entity"]["entity id"]}.png`}
                    col1Num={entityData["entity"]["number of employees"]}
                    overallGrade={String(entityData["entity grade"])}
                    overallGradeImg={`/grades/grade-${entityData["entity grade"]}-hollow.png`}
                    overallScore={String(entityData["entity score"])}
                    overallScoreColor={entityData["color"]}
                  />
                </MDBCol>
                <MDBCol id="entityTable">
                  <CategoryCard
                    tableCategories={entityCategories}
                    heading={"Employee Category Evaluation Level Per Entity"}
                  />
                </MDBCol>

                <MDBCol id="entityRecommend">
                  <ChartCard
                    title={"Entity Recommended Training"}
                    errorMessage={
                      "Entity Recommended training chart data could not be found"
                    }
                    chartInputData={entityTraining}
                  />
                </MDBCol>
              </>
            )}
          </MDBRow>
        </div>
      </div>
    </div>
  );
}
export default ExecutiveDetails;
